import React, { useMemo } from 'react';
import { t } from 'ttag';

import { Button } from '@components';

export default function Unibot() {
  const hasKindly = useMemo(() => !!window?.config?.kindly_enabled, []);
  const hasFaqIframe = useMemo(() => !!window?.config?.faq_iframe_enabled, []);

  if (!hasKindly || hasFaqIframe) return null;

  const openChat = () => window?.kindlyChat?.openChat();

  return (
    <section className="my-4 flex items-center justify-center md:hidden">
      <div className="w-full space-y-4 rounded-lg border border-solid border-gray bg-white p-4">
        <div className="flex flex-col gap-2">
          <span className="text-lg font-bold leading-tight">
            {t`How can I assist you?`}
          </span>
          <span className="leading-tight text-dark-gray">
            {t`I am Unibot 🤖`}
          </span>
          <span className="leading-tight text-dark-gray">
            {t`I can help you with most of your questions.`}
          </span>
        </div>
        <Button size="sm" onClick={() => openChat()}>
          <Button.Text>{t`Chat with me`}</Button.Text>
          <Button.Icon>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M12.1717 12.0005L9.34326 9.17203L10.7575 7.75781L15.0001 12.0005L10.7575 16.2431L9.34326 14.8289L12.1717 12.0005Z" />
            </svg>
          </Button.Icon>
        </Button>
      </div>
    </section>
  );
}
